import {MenuItem} from '@material-ui/core';
import * as O from 'fp-ts/lib/Option';
import {changePremiumMode} from 'Agent/Policies/ducks/policyServiceRequest';
import {DirectBillingScheduleChangeRequest} from 'Agent/Policies/models/ServiceRequest/DirectBillingScheduleChangeRequest';
import {PremiumMode} from 'Agent/Policies/models/ServiceRequest/InitialPolicyServiceRequest';
import React from 'react';
import {useDispatch} from 'react-redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';

type DirectBillingChangeRequestProps = {
  directBillingChangeRequest: DirectBillingScheduleChangeRequest;
};

const DirectBillingChangeRequest = (props: DirectBillingChangeRequestProps) => {
  const {directBillingChangeRequest} = props;
  const dispatch = useDispatch();
  const selectedPremiumMode = O.isSome(directBillingChangeRequest.billingSchedule)
    ? directBillingChangeRequest.billingSchedule.value
    : '';

  return (
    <div>
      <OutlinedSelect
        label="Premium Mode"
        value={selectedPremiumMode}
        className="service-request-form__request-change-type-select"
        onChange={e => dispatch(changePremiumMode(parseInt(e.target.value, 10)))}
      >
        <MenuItem value={PremiumMode.Annual}>Annual</MenuItem>
        <MenuItem value={PremiumMode.PreauthorizedCheckPlan}>Pre-Authorized Check Plan</MenuItem>
        <MenuItem value={PremiumMode.Quarterly}>Quarterly</MenuItem>
        <MenuItem value={PremiumMode.Semiannual}>Semi-Annual</MenuItem>
      </OutlinedSelect>
    </div>
  );
};

export default DirectBillingChangeRequest;
